import { render, staticRenderFns } from "./CustomerCare.vue?vue&type=template&id=2d2b7c28"
import script from "./CustomerCare.vue?vue&type=script&lang=js"
export * from "./CustomerCare.vue?vue&type=script&lang=js"
import style0 from "./CustomerCare.vue?vue&type=style&index=0&id=2d2b7c28&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports